import {
  DEFAULT_PULSE_EMOJIS,
  DEFAULT_PULSE_VALUES,
  pulseLabelForValue,
  pulseValuesMatch,
} from './pulse-scale';

export type AnonymousPulseCycle = {
  content?: {
    pulse?: Array<{
      options?: string[];
      emojis?: string[];
    }>;
  };
};

export type AnonymousPulseBreakdownItem = {
  count: number;
  emoji: string;
  label: string;
  percentage: number;
};

export type AnonymousPulseSummaryData = {
  responseCount: number;
  breakdown: AnonymousPulseBreakdownItem[];
};

export const MIN_ANONYMOUS_PULSE_ANSWERS = 3;

export const buildAnonymousPulseSummary = (
  cycle: AnonymousPulseCycle | null | undefined,
  moods: Array<string | null | undefined>,
): AnonymousPulseSummaryData => {
  const configuredPulse = cycle?.content?.pulse?.[0];
  const options = configuredPulse?.options?.length
    ? configuredPulse.options
    : DEFAULT_PULSE_VALUES;
  const emojis = configuredPulse?.emojis?.length
    ? configuredPulse.emojis
    : DEFAULT_PULSE_EMOJIS;
  const counts = options.map(() => 0);

  moods.forEach((mood) => {
    const optionIndex = options.findIndex((option) =>
      pulseValuesMatch(option, mood),
    );
    if (optionIndex >= 0) counts[optionIndex] += 1;
  });

  const responseCount = counts.reduce((total, count) => total + count, 0);

  return {
    responseCount,
    breakdown: options.map((option, index) => ({
      count: counts[index],
      emoji: emojis[index] || '',
      label: pulseLabelForValue(option),
      percentage: responseCount
        ? Math.round((counts[index] / responseCount) * 100)
        : 0,
    })),
  };
};
